import Avatar from '#components/a/Avatar'
import Profile from '#components/a/Profile'
import {useUserInfo} from '#hooks/store/useUserInfo'
import PropTypes from 'prop-types'
import React from 'react'

export function Userinfo({userId, fallbackUsername}) {
  const userInfo = useUserInfo(userId)

  function renderPlaceholder() {
    return (
      <div className="profile__placeholder">
        <div className="userName" />
        <div className="profile__role" />
      </div>
    )
  }

  const profileImage = !userInfo ? undefined : userInfo.profileImage

  return (
    <div className="userinfo">
      <Avatar profileImage={profileImage} />
      {!userInfo ? renderPlaceholder() : <Profile userInfo={userInfo} fallbackUsername={fallbackUsername} />}
    </div>
  )
}

Userinfo.propTypes = {
  userId: PropTypes.number.isRequired,
  fallbackUsername: PropTypes.string,
}

export default Userinfo
